import React from "react";
import Diehead from "../components/die-component/diehead";
import Dieform from "../components/die-component/dieform";
import Faq1 from "../components/landing/faq";

function Diepage() {
  return (
    <div>
      <Diehead />
      <Dieform />
       <Faq1/>
    </div>
  );
}

export default Diepage;
